import { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "utils/redux";

import { setShowAddModal, setCurrentSection } from "reducers/main";
import { SECTION } from "constants/SettingsConstants";
import { CreateEmployerModal } from "components/Modals";

import "./EmployerPageContainer.scss";

type RREContainerPropTypes = {
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

const EmployerPageContainer = ({
  header,
  footer,
  children,
}: RREContainerPropTypes) => {
  const dispatch = useDispatch();
  const showAddModal = useSelector((state) => state.main.showAddModal);

  useEffect(() => {
    dispatch(setCurrentSection(SECTION.EMPLOYER));
  }, [dispatch]);

  const modal = useMemo(() => {
    return (
      <CreateEmployerModal
        isOpen={showAddModal}
        onClose={() => {
          dispatch(setShowAddModal(false));
        }}
      />
    );
  }, [showAddModal, dispatch]);

  return (
    <>
      {modal}
      <div className="EmployerPageContainer">
        {header && (
          <div className="EmployerPageContainer__Header">{header}</div>
        )}
        <div className="EmployerPageContainer__Forms">{children}</div>
        {footer && (
          <div className="EmployerPageContainer__Footer">{footer}</div>
        )}
      </div>
    </>
  );
};

export default EmployerPageContainer;
